<template>
  <div v-if="isDevelopEnvironment" class="error-message__wrapper">
    <div
      v-for="errorField in filteredDevelopDetails"
      :key="errorField.fieldName"
      class="error-message__message text-caption"
    >
      <p class="error-message__field-name">{{ errorField.fieldName }}</p>
      <p class="error-message__field-value">{{ errorField.value }}</p>
    </div>

    <i class="close-icon close-icon_sm" @click.stop="closeMessage" />
    <i
      class="close-icon close-icon_sm clear-all"
      @click.stop="closeAllMessages"
    />
  </div>
  <div v-else class="error-message__wrapper event-message_production">
    <div class="error-message__message text-caption">
      <p class="error-message__field-value">{{ userMessage }}</p>
      <i class="close-icon close-icon_sm" @click.stop="closeMessage" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { propValidator, PROP_TYPES } from '@fmpedia/validators'

const ERROR_MESSAGE_SHOW_TIMEOUT = 5000

export default {
  name: 'EventMessage',
  props: {
    id: propValidator([PROP_TYPES.STRING]),
    error: propValidator([PROP_TYPES.STRING]),
    statusCode: propValidator([PROP_TYPES.NUMBER], false),
    message: propValidator([PROP_TYPES.STRING], false),
    messageDetail: propValidator([PROP_TYPES.STRING], false),
    userMessage: propValidator([PROP_TYPES.STRING]),
    showMessageToUser: propValidator([PROP_TYPES.BOOLEAN]),
    errorCode: propValidator([PROP_TYPES.STRING], false),
    errorMessage: propValidator([PROP_TYPES.STRING], false),
    requestId: propValidator([PROP_TYPES.STRING], false),
    info: propValidator([PROP_TYPES.STRING], false),
    modelState: propValidator([PROP_TYPES.OBJECT], false),
    componentName: propValidator([PROP_TYPES.STRING], false)
  },
  data() {
    return {
      isActive: false,
      developDetails: [
        {
          fieldName: 'Component Name:',
          value: this.componentName
        },
        {
          fieldName: 'Error (string):',
          value: this.error
        },
        {
          fieldName: 'Status code:',
          value: this.statusCode
        },
        {
          fieldName: 'Message:',
          value: this.message
        },
        {
          fieldName: 'Message Detail:',
          value: this.messageDetail
        },
        {
          fieldName: `User Message: (${
            this.showMessageToUser ? 'visible' : 'hidden'
          })`,
          value: this.userMessage
        },
        {
          fieldName: 'Message from BE:',
          value: this.errorMessage
        },
        {
          fieldName: 'Lifecycle location:',
          value: this.info
        },
        {
          fieldName: 'Model state:',
          value: this.modelState
        },
        {
          fieldName: 'Backend RequestId:',
          value: this.requestId
        }
      ]
    }
  },
  computed: {
    isDevelopEnvironment() {
      return process.env.NODE_ENV === 'development'
    },
    filteredDevelopDetails() {
      return this.developDetails.filter(({ value }) => value)
    }
  },
  methods: {
    ...mapActions({
      removeErrorMessage: 'errors/removeErrorMessage',
      clearErrorMessages: 'errors/clearErrorMessages'
    }),
    closeMessage() {
      this.removeErrorMessage(this.id)
    },
    closeAllMessages() {
      this.clearErrorMessages()
    }
  },
  mounted() {
    if (!this.isDevelopEnvironment) {
      setTimeout(this.closeMessage, ERROR_MESSAGE_SHOW_TIMEOUT)
    }
  }
}
</script>

<style lang="scss" scoped>
.error-message__wrapper {
  position: relative;
  padding: 10px 25px 10px 10px;
  border-radius: 5px;
  background: #c7fffb;
  color: black;

  @include mobile {
    border-radius: 0 0 5px 5px;
  }

  .error-message__message {
    width: auto;
    white-space: nowrap;

    &:not(:first-child) {
      margin-top: 15px;
    }
  }

  .error-message__field-name {
    font-weight: 600;
  }

  .error-message__field-value {
    white-space: normal;
  }

  .close-icon {
    top: 3px;
    right: 3px;
  }

  .close-icon.clear-all {
    top: 3px;
    right: 25px;
    transform: scale(1.3);
  }
}

.error-message__wrapper.event-message_production {
  background: $c--red;
  color: $c--white;

  .close-icon::before,
  .close-icon::after {
    background: $c--white;
  }
}
</style>
